import React from "react";
import Page from "../templates/content-types/page";
import contactData from "../page-data/contact-data";

const Contact = () => {
  return <Page {...contactData} />;
};

export default Contact;
